"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
class Logger {
    constructor(levanteLogger, gameParams, userParams) {
        this.levanteLogger = levanteLogger;
        this.gameParams = gameParams;
        this.userParams = userParams;
    }
    static setInstance(levanteLogger, gameParams, userParams) {
        if (Logger.instance) {
            throw new Error('Logger instance already set');
        }
        Logger.instance = new Logger(levanteLogger, gameParams, userParams);
    }
    static getInstance() {
        if (!Logger.instance) {
            throw new Error('Logger instance not set');
        }
        return Logger.instance;
    }
    capture(name, context) {
        var _a, _b;
        const finalProperties = {
            gameParams: this.gameParams,
            userParams: this.userParams,
            context,
        };
        (_b = (_a = this.levanteLogger) === null || _a === void 0 ? void 0 : _a.capture) === null || _b === void 0 ? void 0 : _b.call(_a, name, finalProperties);
    }
    error(error, context) {
        var _a, _b;
        const finalContext = {
            gameParams: this.gameParams,
            userParams: this.userParams,
            context,
        };
        (_b = (_a = this.levanteLogger) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.call(_a, error, finalContext);
    }
}
exports.Logger = Logger;
